import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { RegistrationContext } from '../../../../contexts';
import { formatPhone } from '../../../../utils';
import voloWhite from '../../../../images/logos/volo-white-logo.svg';
import phone from '../../../../images/icons/white-phone.svg';
import mail from '../../../../images/icons/white-mail.svg';
import styles from '../../../../styles/main.module.scss';

const cx = classNames.bind(styles);
const RegisterHeader = () => {
  const [registerState] = useContext(RegistrationContext);
  const { league = {} } = registerState;
  const { organization = {} } = league;
  const { contact_phone_number, contact_email } = organization;

  return (
    <div className={cx('register-header')}>
      <Link to="/discover">
        <img height="100%" src={voloWhite} alt="city logo" />
      </Link>
      <div className="d-flex">
        <a className="mr-2" href={`mailto:${contact_email}`}>
          <img src={mail} alt="email" />
          &nbsp;Contact Us
        </a>
        <a className="ml-2" href={`tel:${contact_phone_number}`}>
          <img src={phone} alt="phone" />
          &nbsp;{formatPhone(contact_phone_number)}
        </a>
      </div>
    </div>
  );
};

RegisterHeader.propTypes = {};

RegisterHeader.defaultProps = {};

export default RegisterHeader;
